import { useSelector } from "react-redux";
import styles from "./styles.module.scss";
import { getLoaderState } from "@app/lib/features/loader/loaderSlice";

interface LoaderProps {
  showLoader?: boolean;
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ showLoader, text }) => {
  const loader = useSelector(getLoaderState);

  return loader || showLoader ? (
    <div className={styles.cover}>
      <div className={styles.loader} />
    </div>
  ) : null;
};

export default Loader;
